import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Configurator{
	constructor(props){
		const {houseTypeSlug, tourUrl, configuratorUrl, videoUrl}=props;
		this._houseTypeSlug = houseTypeSlug;
		this._tourUrl = tourUrl;
		this._videoUrl = videoUrl;
		this._configuratorUrl = configuratorUrl;
	}
	get houseTypeSlug(){
		return this._houseTypeSlug;
	}
	get tourUrl(){
		return this._tourUrl;
	}
	get videoUrl(){
		return this._videoUrl;
	}
	get configuratorUrl(){
		return this._configuratorUrl;
	}
	static fromJSON(jObject){
		return new Configurator(jObject);
	}
}